import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";

export const fruitDetectExample: TemplateDefinition = {
  mode: "detect",
  slug: "fruit-detect-example",
  version: 1,
  title: "Agriculture",
  description: "Spot ripe produce",
  subdescription: "Single out only the ripe fruit, ready to harvest.",
  thumbnailUuid: BASE_ASSETS.fruit.uuid,
  assets: [BASE_ASSETS.fruit],
  detect: {
    mediaUuid: BASE_ASSETS.fruit.uuid,
    categories: ["ripe fruit"],
    config: {
      output: "box",
    },
  },
};
